import React, { useRef } from "react";
import { useParams, Link } from "react-router-dom";
import LandingContext from "@icoach/landingPage/components/LandingContext";
import CheckinTable from "@icoach/landingPage/checkin/CheckinTable";
import AppointmentScheduleTable from "@icoach/landingPage/appointment/AppointmentScheduleTable";
import EmployeeSchedulePage from "@icoach/employees/schedule/EmployeeSchedulePage";
import AppointmentOverview from "@icoach/appointment/overview/AppointmentOverview";
import { CLUB_HOME_ROUTER, CLUB_EMPLOYEE_SCHEDULE_ROUTER, CLUB_APPOINTMENT_ROUTER } from "@icoach/router/routerPath";
import { LANDING_NAVIGATION_TABS } from "@icoach/constants/";
import { isEqual, isFunction } from "@util/utils";
import { PageLayout } from "@icoach/components";
import useMenusControlled from "@util/hook/useMenusControlled";
import LandingDialogBox from "@icoach/landingPage/dialog/LandingDialogBox";

const LandingPage = () => {
	const { tabs: activeTab } = useParams();
	const apoOptionsRef = useRef({});
	const dialogRef = useRef(null);
	const refreshRef = useRef(null);
	const appointmentDateRef = useRef(null);

	const pageTabs = useMenusControlled([
		{
			label: "來店會員",
			value: LANDING_NAVIGATION_TABS.ARRIVE,
			component: Link,
			frontKey: "C1X02",
			to: CLUB_HOME_ROUTER.ARRIVE,
		},
		{
			label: "預約表",
			value: LANDING_NAVIGATION_TABS.TIME_SCHEDULING,
			component: Link,
			frontKey: "C1X03",
			to: CLUB_APPOINTMENT_ROUTER.GET_TABS_PATH(LANDING_NAVIGATION_TABS.TIME_SCHEDULING),
		},
		{
			label: "每日班表",
			value: LANDING_NAVIGATION_TABS.SHIFT_SCHEDULING,
			component: Link,
			frontKey: "C1X04",
			to: CLUB_EMPLOYEE_SCHEDULE_ROUTER.SHIFT_SCHEDULING,
		},
		{
			label: "預約管理",
			value: LANDING_NAVIGATION_TABS.OVERVIEW,
			component: Link,
			frontKey: "C1X05",
			to: CLUB_APPOINTMENT_ROUTER.GET_TABS_PATH(LANDING_NAVIGATION_TABS.OVERVIEW),
		},
	]);

	const checkinActions = useMenusControlled([
		// {
		// 	label: "進入POS",
		// 	variant: "outlined",
		// 	frontKey: "C12X01",
		// 	as: Link,
		// 	to: CLUB_POS_ROUTER.SCREEN,
		// },
		{
			label: "手動簽到",
			variant: "contained",
			frontKey: "C1X02",
			onClick: () => {
				const { openCheckinDialog } = dialogRef.current || {};
				isFunction(openCheckinDialog) && openCheckinDialog();
			},
		},
	]);

	const appointmentActions = useMenusControlled([
		{
			label: "FA入會約運動",
			variant: "outlined",
			frontKey: "C1X03",
			onClick: () => {
				const { openAppointmentFigureAnalysisFormDialog } = dialogRef.current || {};

				isFunction(openAppointmentFigureAnalysisFormDialog) &&
					openAppointmentFigureAnalysisFormDialog(
						{
							initialData: { appointmentDate: appointmentDateRef.current },
							options: apoOptionsRef.current,
						},
						refreshRef.current,
					);
			},
		},
		{
			label: "會員預約",
			variant: "contained",
			frontKey: "C1X03",
			onClick: () => {
				const { openAppointmentFormDialog } = dialogRef.current || {};
				isFunction(openAppointmentFormDialog) &&
					openAppointmentFormDialog(
						{
							initialData: { appointmentDate: appointmentDateRef.current },
							options: apoOptionsRef.current,
						},
						refreshRef.current,
					);
			},
		},
	]);

	const getActions = () => {
		if (isEqual(activeTab, LANDING_NAVIGATION_TABS.ARRIVE)) {
			return checkinActions;
		}
		if ([LANDING_NAVIGATION_TABS.TIME_SCHEDULING, LANDING_NAVIGATION_TABS.SHIFT_SCHEDULING].some(tab => isEqual(activeTab, tab))) {
			return appointmentActions;
		}
		return null;
	};

	const childContext = {
		options: apoOptionsRef,
		refresh: refreshRef,
		dialogRef: dialogRef,
		appointmentDateRef: appointmentDateRef,
		setOptions: params => (apoOptionsRef.current = { ...params }),
		setRefresh: el => (refreshRef.current = el),
		setDialogRef: el => (dialogRef.current = el),
		setAppointmentDateRef: el => (appointmentDateRef.current = el),
	};

	return (
		<LandingContext.Provider value={childContext}>
			<PageLayout className="landing-page">
				<PageLayout.Tabs className="sticky-header mb-0" activeTab={activeTab} tabs={pageTabs} actions={getActions()} />
				{isEqual(activeTab, LANDING_NAVIGATION_TABS.ARRIVE) && <CheckinTable />}
				{isEqual(activeTab, LANDING_NAVIGATION_TABS.TIME_SCHEDULING) && <AppointmentScheduleTable />}
				{isEqual(activeTab, LANDING_NAVIGATION_TABS.SHIFT_SCHEDULING) && <EmployeeSchedulePage />}
				{isEqual(activeTab, LANDING_NAVIGATION_TABS.OVERVIEW) && <AppointmentOverview />}
			</PageLayout>
			<LandingDialogBox ref={dialogRef} />
		</LandingContext.Provider>
	);
};

export default LandingPage;
